import {useDispatch, useSelector} from 'react-redux';

import SaleAgentCard from '../../../../../components/mazraeKit/cards/saleAgentCard';
import OperationSaleAgentBottomSheet from '../../elements/bottomSheetLists/operationSaleAgentBottomSheet';
import {addSaleAgentForm} from '../../../../../store/redux/salesAgent';
import {RootState} from '../../../../../store/redux';

export const SaleAgentsListing = ({
  saleAgentList,
  saleAgentsBottomSheet,
  setSaleAgentsBottomSheet,
  refetchGetSaleAgentList,
  assigner_store,
}: ISaleAgentListingProps) => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.saleAgent);

  return (
    <div className="flex flex-col gap-3 ">
      {saleAgentList?.map(item => {
        return (
          <SaleAgentCard
            storeName={item.name}
            address={item.address}
            phone={item.phone_number}
            state={item.state}
            city={item.city}
            onClick={() => {
              dispatch(
                addSaleAgentForm({
                  ...state,
                  cardGuid: item.guid,
                  store_name: item.name,
                }),
              );
              setSaleAgentsBottomSheet({
                position: true,
                type: 'editDelete',
              });
            }}
          />
        );
      })}
      <OperationSaleAgentBottomSheet
        {...{
          saleAgentsBottomSheet,
          setSaleAgentsBottomSheet,
          refetchGetSaleAgentList,
          assigner_store,
        }}
      />
    </div>
  );
};

export default SaleAgentsListing;
